import { useLocation, useNavigate } from "react-router-dom";
import { CompaniesService } from "./CompaniesService";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { useUserNew } from "src/api/client-api/useUserNew";

export const useSwitchCompany = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedCompany, setSelectedCompany } = useFoodpilotContext();
    const { user } = useUserNew();

    const switchUrl = (companyId: number) => {
        CompaniesService.switchCompany(companyId);
        const newUrl = CompaniesService.switchCompanyURL(companyId, location.pathname);

        if (newUrl === undefined) {
            return;
        }
        if (user?.companies) {
            const newSelectedCompany = CompaniesService.selectCurrentCompany(user.companies, companyId);
            setSelectedCompany(newSelectedCompany);
        }

        navigate(newUrl);
    };
    if (selectedCompany === null) {
        CompaniesService.resetCompany();
    }

    return {
        changeCompany: switchUrl,
    };
};
